export default "__VITE_ASSET__Bs1vL3xg__"